export default {
  subscriptionplanList(state) {
    return state.subscriptionplanList;
  },
  geteditSubscription(state) {
    return state.currentSubscriptionObject;
  }
};
